export const CLOSE = new Set(["Back", "Backspace", "BrowserBack", "Escape", "GoBack"]);
